export default __webpack_public_path__ + "static/18_My100000thDream-468a4d82fc9bb09e923b8792f2a624c9.pdf";